/**
 * Enterprise presentation / demo kiosk — isolated from live salon hub flows.
 * Update credentials and guest profile here (or via REACT_APP_PRESENTATION_* env vars).
 */

export const PRESENTATION_FRANCHISE_USERNAME =
  process.env.REACT_APP_PRESENTATION_FRANCHISE_USERNAME || 'nt01';

export const PRESENTATION_FRANCHISE_CODE =
  process.env.REACT_APP_PRESENTATION_FRANCHISE_CODE || 'nt01';

export const PRESENTATION_FRANCHISE_PASSWORD =
  process.env.REACT_APP_PRESENTATION_FRANCHISE_PASSWORD || 'abcd1234';

export const PRESENTATION_CUSTOMER_NAME =
  process.env.REACT_APP_PRESENTATION_CUSTOMER_NAME || 'Guest';

export const PRESENTATION_CUSTOMER_MOBILE =
  process.env.REACT_APP_PRESENTATION_CUSTOMER_MOBILE || '8122147959';

/** Reels: service type id (see enterprise/video ServiceSelect SERVICES). */
export const PRESENTATION_REELS_SERVICE_TYPE_ID =
  process.env.REACT_APP_PRESENTATION_REELS_SERVICE_TYPE || 'haircut';

/** Desk “started service” label for reel-eligible check-in. */
export const PRESENTATION_REELS_STARTED_SERVICE_NAME =
  process.env.REACT_APP_PRESENTATION_REELS_SERVICE_NAME || 'Haircut';

/** Customer Engage demo (Naturals) app URL. Tile is hidden when unset. Opens in a new tab. */
export const PRESENTATION_CUSTOMER_ENGAGE_URL = (process.env.REACT_APP_DEMO_ENGAGEMENT_APP_URL || '').trim();

/** Fixed presentation hub backdrop (not franchise kiosk landing). */
export const PRESENTATION_HUB_BACKGROUND_PATH =
  '/demo-engagement/Lavender Luxe Spa with Golden Light.png';

export function presentationHubBackgroundStyle() {
  const url = encodeURI(
    `${process.env.PUBLIC_URL || ''}${PRESENTATION_HUB_BACKGROUND_PATH}`,
  );
  return { '--naturals-hub-bg': `url("${url}")` };
}

export const PRESENTATION_HUB_PATH = '/enterprise/presentation';
export const PRESENTATION_LOGIN_PATH = '/enterprise/presentation/login';
